import React from "react";
import _ from "lodash";
import { Separator, Text } from "@showitinc/showit-wc";
import ButtonBar from "../SetupButtonBar";
import ViewPanel from "../ViewPanel";
import Constants from "../Constants";
import useSubmitSetupRequest from "../hooks/useSubmitSetupRequest";
import { invalidateUserBlogDomains } from "../../../hooks/query/useUserBlogDomains";
import { filterSetupData } from "../utils";

function getSetupRequest(blogSetup) {
  const { setupData, migrationRequired, setupRequestId } = blogSetup;

  return {
    migrationRequired,
    setupRequestId,
    setupData: filterSetupData(setupData, Constants.SETUP_REQUEST_FIELDS),
  };
}

function Confirm({ blogSetup, actions }) {
  const { setupData } = blogSetup;
  const [submitRequest, { isPending, isError }] = useSubmitSetupRequest();

  const submit = async () => {
    const { userId } = blogSetup;
    const setupRequest = getSetupRequest(blogSetup);
    await submitRequest(
      { userId, setupRequest },
      {
        onSuccess: (data) => {
          actions.updateUser({
            blogId: data.blogDomain.wp_host_id,
            blogStatus: data.blogDomain.status,
          });
          actions.assignBlogToSite(data.blogDomain);
          actions.goToNextStep();
        },
      }
    );
    invalidateUserBlogDomains();
  };

  const btnText = isPending ? "Submitting..." : "Submit";
  const btnAction = isPending ? undefined : submit;

  return (
    <ViewPanel>
      {{
        content: (
          <>
            <Text variant="heading-2" variantStyle="strong">
              Review
            </Text>
            <Separator />
            <Text>
              Setting up your new blog is not immediate. <br />
              <a
                href="https://learn.showit.co/launching-your-site/pre-launch/estimated-turnaround-times-for-launch"
                target="_blank"
                rel="noreferrer"
              >
                Learn more about estimated turnaround time
              </a>
              .
            </Text>
            {isError ? (
              <div className="has-error">
                <div className="help-block">A problem occurred while submitting your request</div>
              </div>
            ) : undefined}
          </>
        ),
        actions: (
          <ButtonBar
            onForward={btnAction}
            onBack={actions.goToPrevStep}
            allowForward={btnAction !== undefined}
            allowBack
            forwardBtnText={btnText}
          />
        ),
      }}
    </ViewPanel>
  );
}

export default Confirm;
